import { render, staticRenderFns } from "./AboutProposito.vue?vue&type=template&id=7536cf46&scoped=true&"
import script from "./AboutProposito.vue?vue&type=script&lang=js&"
export * from "./AboutProposito.vue?vue&type=script&lang=js&"
import style0 from "./AboutProposito.vue?vue&type=style&index=0&id=7536cf46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7536cf46",
  null
  
)

export default component.exports